import cx from 'clsx';
import * as React from 'react';

import { CarouselSlider } from '@/components/Carousel';
import HeaderSlot from '@/components/Header/HeaderSlot';
import { HeaderNavigationProps } from '@/components/Header/types';
import SubNavigation from '@/components/SubNavigation';
import config from '@/config';
import { isHybrid888 } from '@/utils/isHybrid888';

import styles from './HeaderNavigation.module.scss';

const HeaderNavigation: React.FC<HeaderNavigationProps> = ({
  items,
  onItemClick,
  navHorizontalPadding = 0,
  activeIndicatorColor,
  onNavigationCommandClick,
  onNavigationGameClick,
  onNavigationGameInfoClick,
  visible = true,
  onMenuItemClick,
  initialScrollValue,
  currentPagePath,
  pageTitle,
  initialLoad,
}) => {
  if (!visible || !items.length) return null;

  const shouldHideNavigationInLayout =
    currentPagePath.includes(config.functionalities?.gameDetails?.path) &&
    config.features?.iFrame?.mode === 'disabled';

  const isHybrid888App = isHybrid888();

  const activeItem = items.find(
    item =>
      item.route_link === currentPagePath ||
      item.routes.find(r => r.route_link === currentPagePath)
  );

  /**
   * Don't remove sub navigation when modal is displayed
   * so content doesn't jump during animation on mobile devices.
   * Temporary solution until new Navigation
   */
  const subNavItems = shouldHideNavigationInLayout ? items[0] : activeItem;

  return (
    <div
      className={cx(
        styles.wrapper,
        styles[`wrapper__${navHorizontalPadding}`],
        { [styles.wrapperNoResults]: !activeItem?.routes },
        isHybrid888App && styles.wrapperHybrid888
      )}
      data-testid="header-wrapper"
    >
      <div
        className={cx(
          styles.mainNavContainer,
          isHybrid888App && styles.mainNavContainerHybrid888
        )}
      >
        <CarouselSlider
          styleProp={'slider'}
          edgeSlidesPadding={navHorizontalPadding}
        >
          {items.map((item, index) => (
            <div
              className={cx(
                styles.slot,
                isHybrid888App && styles.slotHybrid888
              )}
              key={index}
              data-testid={`${index}-slot`}
            >
              <HeaderSlot
                data-testid={`${index}-header-slot`}
                item={item}
                onItemClick={onItemClick}
                activeIndicatorColor={activeIndicatorColor}
                onNavigationCommandClick={onNavigationCommandClick}
                onNavigationGameClick={onNavigationGameClick}
                onNavigationGameInfoClick={onNavigationGameInfoClick}
                index={index}
                pageTitle={pageTitle}
              />
            </div>
          ))}
        </CarouselSlider>
      </div>
      <SubNavigation
        items={subNavItems?.routes || []}
        onMenuItemClick={onMenuItemClick}
        initialScrollValue={initialScrollValue}
        isSubNavigation={
          shouldHideNavigationInLayout || initialLoad
            ? true
            : !!(activeItem?.routes && activeItem.routes.length)
        }
      />
    </div>
  );
};

export default HeaderNavigation;
